import { render, staticRenderFns } from "./PostSearch.vue?vue&type=template&id=4f50a1b2"
import script from "./PostSearch.vue?vue&type=script&lang=js"
export * from "./PostSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports